import { Doc } from '@dadohr/shared/domainTypes/document';
import {
  EnrollmentFormSubmissionStatus,
  IEnrollmentForm
} from '@dadohr/shared/domainTypes/enrollmentForms';
import { Button } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import { CountBubble } from '../../../../../components/CountBubble';
import { useUnsafeTranslation } from '../../../../../i18next';
import { FlexContainer } from '../../../../../layout/Flex';
import { useEnrollSubmissionById } from '../../../../../services/experiences/enrollmentForms';
import { useMappedLoadingValue } from '../../../../../services/firebase';

export const EnrollmentFormSubmissionsBanner = ({
  d,
  onViewSubmissions
}: {
  d: Doc<IEnrollmentForm>;
  onViewSubmissions?: () => void;
}) => {
  const { t } = useUnsafeTranslation();

  const [ds] = useMappedLoadingValue(
    useEnrollSubmissionById(d.id, d.data.orgId),
    (ss) =>
      ss.filter((s) => s.data.status === EnrollmentFormSubmissionStatus.PENDING)
  );
  if (!ds || !ds.length) {
    return null;
  }
  return (
    <Alert
      severity="warning"
      icon={
        <FlexContainer
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <CountBubble value={ds.length} color="yellow" />
        </FlexContainer>
      }
      action={
        onViewSubmissions && (
          <Button
            variant="outlined"
            color="inherit"
            onClick={() => onViewSubmissions()}
          >
            {t('Review')}
          </Button>
        )
      }
    >
      {t('You have new enrollment submissions to review')}
    </Alert>
  );
};
